// this.$store.state.cuestionarios
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";
import { colecciones } from "../constantes";

// CUESTIONARIOS
export const cuestionarios = {
  panelAdministrativo: {
    seguridadVial: {
      plantilla: {
        objeto: class {
          constructor() {
            return {
              id: "",
              nombre: "",
              categoria: "",
              secciones: [],
              estado: "Pendiente",
              registro: {
                filtro: moment().format("YYYY-MM-DD"),
                estado: "Creado",
                idUsuario: "",
                creacion: serverTimestamp(),
                actualizacion: serverTimestamp(),
              },
            };
          }
        },
        funciones: {
          async crear(plantilla) {
            await setDoc(
              doc(
                db,
                colecciones.firebase.panelAdministrativo.seguridadVial
                  .cuestionarios.plantillas.registros,
                plantilla.id,
              ),
              plantilla,
            );
          },
          async actualizar(plantilla) {
            await updateDoc(
              doc(
                db,
                colecciones.firebase.panelAdministrativo.seguridadVial
                  .cuestionarios.plantillas.registros,
                plantilla.id,
              ),
              {
                nombre: plantilla.nombre,
                categoria: plantilla.categoria,
                secciones: plantilla.secciones,
                estado: plantilla.estado,
                "registro.estado": "Editado",
                "registro.actualizacion": serverTimestamp(),
              },
            );
          },
          async eliminar(id) {
            await updateDoc(
              doc(
                db,
                colecciones.firebase.panelAdministrativo.seguridadVial
                  .cuestionarios.plantillas.registros,
                id,
              ),
              {
                "registro.estado": "Eliminado",
                "registro.actualizacion": serverTimestamp(),
              },
            );
          },
          async obtener(id) {
            const q = query(
              collection(
                db,
                colecciones.firebase.panelAdministrativo.seguridadVial
                  .cuestionarios.plantillas.registros,
              ),
              where("id", "==", id),
              where("registro.estado", "in", ["Creado", "Editado"]),
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.length > 0
              ? querySnapshot.docs[0].data()
              : null;
          },
          async generarID() {
            const refPlantilla = doc(
              collection(
                db,
                colecciones.firebase.panelAdministrativo.seguridadVial
                  .cuestionarios.plantillas.registros,
              ),
            );
            return refPlantilla.id;
          },
        },
      },
    },
  },
  seguridadVial: {
    registro: {
      objeto: class {
        constructor() {
          return {
            id: "",
            idEmpresa: "",
            nombre: "",
            categoria: "",
            secciones: [],
            estado: "Pendiente",
            registro: {
              filtro: moment().format("YYYY-MM-DD"),
              estado: "Creado",
              idUsuario: "",
              creacion: serverTimestamp(),
              actualizacion: serverTimestamp(),
            },
          };
        }
      },
      funciones: {
        async crear(cuestionario) {
          await setDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.cuestionarios.registros,
              cuestionario.id,
            ),
            cuestionario,
          );
        },
        async actualizar(cuestionario) {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.cuestionarios.registros,
              cuestionario.id,
            ),
            {
              nombre: cuestionario.nombre,
              categoria: cuestionario.categoria,
              secciones: cuestionario.secciones,
              estado: cuestionario.estado,
              "registro.estado": "Editado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        },
        async eliminar(id) {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.cuestionarios.registros,
              id,
            ),
            {
              "registro.estado": "Eliminado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        },
        async obtener(id) {
          const q = query(
            collection(
              db,
              colecciones.firebase.seguridadVial.cuestionarios.registros,
            ),
            where("id", "==", id),
            where("registro.estado", "in", ["Creado", "Editado"]),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs[0].data()
            : null;
        },
        async generarID() {
          const refCuestionario = doc(
            collection(
              db,
              colecciones.firebase.seguridadVial.cuestionarios.registros,
            ),
          );
          return refCuestionario.id;
        },
      },
    },
  },
};
